<template>
  <aside class="col-12 col-md-4 py-4">
    <img class="w-100" v-bind:src="'/assets/images/products/' + image" />
  </aside>
</template>

<script>

export default {
  name: 'StoCscResultItemAside',
  props: {
    image: String
  }
}

</script>
